import tw, { styled } from 'twin.macro';

export const HitsWrapper = styled.div(tw`pb-6 mb-4 px-4 border-b border-b-borderColor`);
export const HitsItemList = styled.ul(tw`pt-2`);
